import Head from 'next/head';

import { getDescription, getSearch } from '@/Layout/Search/service';
import Search from '@/Layout/Search';
import settings from '@/settings.js';

export const getServerSideProps = async ({ params, req }: any) => {
  const [category, state, city, search]: any = params.params;
  const urlParts = req.headers['x-forwarded-host'].split('.');
  if(state){
    const isSikarPresent = settings?.city.some(cityObj => cityObj?.value?.toLowerCase() === state?.toLowerCase());

    if (!isSikarPresent) {
      return {
        redirect: {
          destination: '/404', // Replace with your custom 404 page URL if needed
          permanent: false,
        },
      };
    }
  }
  if (urlParts.length >= 3) {
    return {
      redirect: {
        destination: `https://247torax.com${req.url}`,
        permanent: false, // Set to true if this is a permanent redirect (301)
      },
    };
  }

  if (category != 'escorts') {
    return {
      redirect: {
        destination: '/404', // Replace with your custom 404 page URL if needed
        permanent: false,
      },
    };
  }
  if (state == 'Hyderabad') {
    return {
      redirect: {
        destination: '/escorts/hyderabad', // Replace with your custom 404 page URL if needed
        permanent: false,
      },
    };
  }
  if (state == 'Chennai') {
    return {
      redirect: {
        destination: '/escorts/chennai', // Replace with your custom 404 page URL if needed
        permanent: false,
      },
    };
  }

  console.log({
    category: category,
    state: state,
    city: city,
    search: search,
  });
  const getDescriptions = (await getDescription({
    payload: {
      category: category,
      state: state,
      city: city,
      search: search,
    },
  })) as any;

  const getData = (await getSearch({
    payload: {
      limit: 10,
      page: 1,
      category: category,
      state: state,
    },
  })) as any;
  return { props: { getDescriptions, getData: getData.data.result, params } };
};

function Index({ getDescriptions, getData, params }: any) {
  let baseUrl = process.env.REACT_BASE_URL;
  if (params?.params?.category) {
    baseUrl = process.env.REACT_BASE_URL + `/${params?.params?.category}`;
  }
  if (params?.params?.category && params?.params?.state) {
    baseUrl = process.env.REACT_BASE_URL + `/${params?.params?.category}/${params?.params?.state}`;
  }
  const homePage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '247torax #1 Escort Classified Site | Call Girl in India',
    description:
      'Meet with the high-profile call girls in your city. Find the call girl in Chennai, Bangalore, Hyderabad, Jaipur, Pune, Mumbai, Udaipur. POST YOUR AD absolutely FREE!',
    url: baseUrl,
  };
  return (
    <>
      <Head>
        <title>{getDescriptions.data?.titleTag}</title>
        <meta name="title" content={getDescriptions.data?.titleTag} />
        <meta name="description" content={getDescriptions.data?.descriptionTag} />
        <meta name="keyword" content={getDescriptions.data?.keywordTag} />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homePage) }}></script>
      </Head>
      <Search descriptionData={getDescriptions.data} listData={getData} />
    </>
  );
}
Index.auth = false;

export default Index;
